/**
 * Standardized garment part names for interactive selection.
 *
 * Phase 4a of the visual editor redesign. Not all garment types
 * have all parts; `body` is always present on tagged types.
 */

export const GARMENT_PARTS = [
  "body",
  "sleeve_left",
  "sleeve_right",
  "collar",
  "cuff_left",
  "cuff_right",
  "pocket_left",
  "pocket_right",
  "placket",
  "waistband",
  "hem",
  "yoke",
] as const;

export type GarmentPart = (typeof GARMENT_PARTS)[number];

/** Wrap SVG content in a named part group. */
export function partGroup(name: GarmentPart, innerSvg: string): string {
  return `<g data-part="${name}">${innerSvg}</g>`;
}
